/** @graphql cc **/
import type { GraphQLTaggedNode } from 'react-relay';
import { graphql } from 'react-relay';

export const ConsumerSpaceQuery: GraphQLTaggedNode = graphql`
	query ConsumerSpaceQuery($contentId: ID!) {
		content(id: $contentId, status: ["current", "draft"]) {
			nodes {
				id
				space {
					key
				}
			}
		}
	}
`;
